import api from "./client";

/* Operations documents + industry library — backend documents_app/ops_views.py.
   The tenant's industry decides what the library offers (events, landscaping, …);
   adopting a starter copies it in (a SOP lands as an unpublished draft in /operations/sops).
   Reads: any staff. Adopt / create / edit: admin or manager (server-gated). Attach: any staff. */

export const getOpsLibrary = (pack) => api.get("/documents/ops/library/", { params: pack ? { pack } : {} });
export const adoptStarter = (key, pack) => api.post("/documents/ops/library/adopt/", pack ? { key, pack } : { key });

export const listOpsDocs = () => api.get("/documents/ops/docs/");
export const getOpsDoc = (id) => api.get(`/documents/ops/docs/${id}/`);
export const createOpsDoc = (body) => api.post("/documents/ops/docs/", body);
export const updateOpsDoc = (id, body) => api.patch(`/documents/ops/docs/${id}/`, body);

// target: { quote } | { job } | { appointment } — exactly one, a uuid
export const attachOpsDoc = (id, target) => api.post(`/documents/ops/docs/${id}/attach/`, target);
export const listBookingDocs = (target) => api.get("/documents/ops/attachments/", { params: target });
export const detachOpsDoc = (attachmentId) => api.delete(`/documents/ops/attachments/${attachmentId}/`);

// the tenant's own file (PDF/DOCX) goes through the storage library first, then is linked by id
export const uploadOpsFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("category", "document");
  return api.post("/storage/files/upload/", fd, { headers: { "Content-Type": "multipart/form-data" } });
};

// "Generate starter documents": the whole industry pack as drafts + every question slot queued.
// pack: platform-owner preview of another vertical (e.g. on the internal tenant); omit for your own.
export const generateStarters = (pack) => api.post("/documents/ops/generate/", pack ? { pack } : {});

// The question queue. An answer fills every document that uses it and the business's knowledge
// (what the assistant / receptionist / quotes read). value: {choice|yes|amount|number|text}
export const listOpsQuestions = (openOnly) => api.get("/documents/ops/questions/", { params: openOnly ? { open: 1 } : {} });
export const answerOpsQuestion = (key, value, text) =>
  api.post(`/documents/ops/questions/${encodeURIComponent(key)}/answer/`, text === undefined ? { value } : { value, text });

// A person confirms one counsel-flagged section, then the document.
export const confirmOpsSection = (id, sectionId) => api.post(`/documents/ops/docs/${id}/confirm-section/`, { section_id: sectionId });
export const confirmOpsDoc = (id) => api.post(`/documents/ops/docs/${id}/confirm/`);
